import { render, staticRenderFns } from "./noput.vue?vue&type=template&id=6bdadcad&scoped=true"
import script from "./noput.vue?vue&type=script&lang=js"
export * from "./noput.vue?vue&type=script&lang=js"
import style0 from "./noput.vue?vue&type=style&index=0&id=6bdadcad&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdadcad",
  null
  
)

export default component.exports